export default {"src":"/_next/static/media/home.3d1ac7b3.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};